import { render, staticRenderFns } from "./CustomerAdd.vue?vue&type=template&id=0067a1c7&scoped=true"
import script from "./CustomerAdd.vue?vue&type=script&lang=ts"
export * from "./CustomerAdd.vue?vue&type=script&lang=ts"
import style0 from "./CustomerAdd.vue?vue&type=style&index=0&id=0067a1c7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0067a1c7",
  null
  
)

export default component.exports